import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const dailyQuestions = [
  { zh: '今天，你感恩什麼？', en: 'What are you grateful for today?' },
  { zh: '今天，生命在哪裡讓你驚喜？', en: 'Where did Life surprise you today?' },
  { zh: '今天，有什麼安靜地等待你的注意？', en: 'What is quietly asking for your attention today?' },
  { zh: '今天，生命正在恢復你什麼能力？', en: 'What ability is Life restoring today?' },
];

export default function LivingQuestionsSection() {
  const { t } = useTranslation();
  const [answer, setAnswer] = useState('');
  const [saved, setSaved] = useState(false);

  // Use day of month to pick question (deterministic but rotating)
  const todayIndex = new Date().getDate() % dailyQuestions.length;
  const todayQuestion = dailyQuestions[todayIndex];

  const handleSave = useCallback(() => {
    if (answer.trim()) {
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    }
  }, [answer]);

  return (
    <section className="w-full bg-background-100/50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        {/* Header */}
        <div className="text-center mb-8">
          <h2
            className="text-lg md:text-xl text-foreground-800 mb-1"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {t('journey.livingQuestions.title')}
          </h2>
          <p className="text-xs text-foreground-400">{t('journey.livingQuestions.titleZh')}</p>
          <p className="text-xs text-foreground-400 mt-1 italic">
            {t('journey.livingQuestions.subtitle')}
          </p>
        </div>

        {/* Today's Question Card */}
        <div className="max-w-lg mx-auto bg-background-50 border border-foreground-200/40 rounded-xl p-5 md:p-6">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-question-mark text-primary-500 text-sm" />
            </div>
            <p className="text-xs text-foreground-400 uppercase tracking-wider">
              {t('journey.livingQuestions.todayQuestion')}
            </p>
          </div>

          <p className="text-base md:text-lg text-foreground-800 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
            {todayQuestion.zh}
          </p>
          <p className="text-xs text-foreground-400 italic mb-5">
            {todayQuestion.en}
          </p>

          {/* Answer area */}
          {!saved ? (
            <>
              <textarea
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                maxLength={300}
                rows={3}
                className="w-full px-3 py-2.5 rounded-md border border-foreground-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:ring-1 focus:ring-primary-300 resize-none"
                placeholder={t('journey.livingQuestions.answerPlaceholder')}
              />
              <div className="flex items-center justify-between mt-3">
                <p className="text-[11px] text-foreground-400">
                  {answer.length} / 300
                </p>
                <button
                  onClick={handleSave}
                  disabled={!answer.trim()}
                  className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t('gratitude.layer3.send')}
                </button>
              </div>
            </>
          ) : (
            <div className="text-center py-4">
              <i className="ri-check-line text-primary-500 text-xl mb-2 inline-block" />
              <p className="text-sm text-primary-700">
                {t('gratitude.submitted')}
              </p>
            </div>
          )}

          {/* Note */}
          <p className="text-[11px] text-foreground-400 mt-4 pt-3 border-t border-foreground-100 leading-relaxed">
            {t('journey.livingQuestions.noAnalysis')}
          </p>
        </div>
      </div>
    </section>
  );
}